import React from 'react';
import PropTypes from 'prop-types';
import './petDetailRadio.scss';
import { PetDetailRadio } from './petDetailRadio';
import { FullPetDetailsPropTypes } from '../../propTypes/petDetails';
import { revertLegacyPolicyNumberFormat } from '../../helpers/paymentHelper';
import { usePetPhotoUrl } from '../../hooks/usePetPhotoUrl';

const PetDetailsRadioItem = ({
  fullPetInfo,
  petIndex,
  groupName,
  isChecked,
  isIconOnly,
  isReadOnly,
  hasImageBackground,
  onChange
}) => {
  const { PolicyDetails, ...petDetail } = fullPetInfo;
  const backgroundImageUrl = usePetPhotoUrl(petDetail.PetBackGroundImage, petDetail.FullPolicyNumber);

  return (
    <section
      style={hasImageBackground && backgroundImageUrl ? { backgroundImage: `url(${backgroundImageUrl})` } : {}}
      className="petDetailSection"
    >
      <PetDetailRadio
        groupName={groupName}
        isChecked={isChecked({ PolicyDetails, petIndex })}
        isIconOnly={isIconOnly}
        isReadOnly={isReadOnly}
        policyDetails={PolicyDetails}
        petDetail={petDetail}
        onChange={onChange}
        validation={{ required: 'Please select a pet' }}
      />
    </section>
  );
};

PetDetailsRadioItem.propTypes = {
  fullPetInfo: FullPetDetailsPropTypes,
  petIndex: PropTypes.number.isRequired,
  groupName: PropTypes.string.isRequired,
  isChecked: PropTypes.func.isRequired,
  isIconOnly: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  hasImageBackground: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export const PetDetailsRadios = ({
  petDetails,
  isIconOnly = false,
  hasImageBackground = false,
  isReadOnly,
  value,
  onChange = () => {}
}) => {
  const isChecked = ({ PolicyDetails, petIndex }) => {
    if (value) {
      const formattedValue = revertLegacyPolicyNumberFormat(value);
      return formattedValue === PolicyDetails.PolicyNo || formattedValue === petDetails[petIndex].FullPolicyNumber;
    }
    return petDetails?.length === 1;
  };

  return (
    <div className={`petDetailsRadioWrapper ${isReadOnly ? 'readOnly' : ''} ${isIconOnly ? 'iconOnly' : ''}`}>
      {petDetails?.map((fullPetInfo, petIndex) => (
        <PetDetailsRadioItem
          key={fullPetInfo.FullPolicyNumber}
          fullPetInfo={fullPetInfo}
          petIndex={petIndex}
          groupName="petDetailsRadios"
          isChecked={isChecked}
          isIconOnly={isIconOnly}
          isReadOnly={isReadOnly}
          hasImageBackground={hasImageBackground}
          onChange={onChange}
        />
      ))}
    </div>
  );
};

PetDetailsRadios.propTypes = {
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  isReadOnly: PropTypes.bool,
  isIconOnly: PropTypes.bool,
  hasImageBackground: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func
};
